import { type RadiusLegacyKeys, radiusLegacy } from "./legacy/token-radius";

export const radiusTokens = {
  radius0: 0, // Full-width elements, content containers
  radiusS: 8, // Text fields, cards, image containers
  radiusM: 16, // Content containers
  radiusL: 24, // Modals and overlays
  radiusXL: 48, // Marketing containers
  radiusFull: 999, // Buttons, avatars, pills
} as const;

export type RadiusTokensKeys = keyof typeof radiusTokens;

// Combined export for backward compatibility
export const radius: typeof radiusTokens & typeof radiusLegacy = {
  ...radiusLegacy,
  ...radiusTokens,
};

export type RadiusKeys = RadiusTokensKeys | RadiusLegacyKeys;
